import { createFileRoute, notFound } from "@tanstack/react-router";
import { getBrandCategory } from "@/lib/brandConfig";
import BrandCategoryLanding from "@/pages/BrandCategoryLanding";

export const Route = createFileRoute("/brand/$brandSlug/$categorySlug")({
  beforeLoad: ({ params }) => {
    if (!getBrandCategory(params.brandSlug, params.categorySlug)) throw notFound();
  },
  head: ({ params }) => {
    const canonicalUrl = "https://www.garden-review.co.uk" + `/brand/${params.brandSlug}/${params.categorySlug}`;
    return {
      links: [{ rel: "canonical", href: canonicalUrl }],
    };
  },
  component: BrandCategoryLanding,
});
